'use client'

import { v4 as uuidv4 } from 'uuid'

/**
 * Get or generate a session ID for ad tracking
 * Uses sessionStorage to persist across page loads but expires when browser closes
 * This is GDPR compliant as it's anonymous and temporary
 *
 * Uses the industry-standard uuid package for universal browser compatibility
 * Works in all contexts (HTTP/HTTPS, all browsers including older ones)
 *
 * @returns {string|null} Session ID or null if on server
 */
export function getSessionId() {
  // Return null during SSR
  if (typeof window === 'undefined') return null

  // Check if we already have a session ID
  let sessionId = sessionStorage.getItem('gf_ad_session_id')

  if (!sessionId) {
    // Generate a new UUID for this session using the uuid package
    // This is cryptographically secure and works in all browsers/contexts
    sessionId = uuidv4()
    sessionStorage.setItem('gf_ad_session_id', sessionId)
  }

  return sessionId
}

/**
 * Clear the current session ID (useful for testing or forced session reset)
 */
export function clearSessionId() {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem('gf_ad_session_id')
}
